// Indian number formatting helpers for the DIY planner.

export const formatINR = (n) => {
    const num = Number(n);
    if (!isFinite(num)) return "—";
    return new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(num);
};

export const formatMoney = (n) => `₹${formatINR(n)}`;

// Compact Indian display: ₹2.35 Cr / ₹45.2 L / ₹80,500
export const formatCompact = (n) => {
    const num = Number(n);
    if (!isFinite(num)) return "—";
    const abs = Math.abs(num);
    const sign = num < 0 ? "-" : "";
    if (abs >= 1e7) return `${sign}₹${(abs / 1e7).toFixed(2)} Cr`;
    if (abs >= 1e5) return `${sign}₹${(abs / 1e5).toFixed(1)} L`;
    return `${sign}₹${formatINR(abs)}`;
};

export const parseNum = (s) => {
    if (s === "" || s === null || s === undefined) return "";
    const cleaned = String(s).replace(/[^0-9.]/g, "");
    if (cleaned === "") return "";
    const n = Number(cleaned);
    return isFinite(n) ? n : "";
};
